<template>
    <fieldset>
        <div class="order-header" v-show="step === 6">
            <i class="ion-card"></i>
            <h2>Płatność online (Zamówienie nr {{ orderData.orderNumber }})</h2>
        </div>

        <div class="order-summary-table" v-if="step === 6">
            <div class="desktop-order-summary">
                <div class="dos-name-section" style="min-height: 100px">
                    <h3>Nadawca</h3>
                    <p>
                        {{ orderData.customer.FirstName }}
                        {{ orderData.customer.LastName }}
                    </p>
                    <p>
                        {{ orderData.address.Street }}
                        {{ orderData.address.StreetNo }}
                    </p>
                    <p>
                        {{ orderData.address.PostalCode }}
                        {{ orderData.address.City }}
                    </p>
                    <p></p>
                </div>
                <div class="dos-name-section" style="min-height: 100px">
                    <h3>Odbiorca</h3>
                    <p>DTS Transport Sp. z o.o.</p>
                    <p>ul. Wał Miedzeszyński 251,</p>
                    <p>04-866 Warszawa</p>
                    <p></p>
                </div>
                <div class="dos-address-section">
                    <h3>Forma płatności</h3>
                    <p>Przelew online</p>
                </div>
                <div class="dos-address-section">
                    <h3>Kwota do zapłaty</h3>
                    <p>{{ orderData.delivery.cost | toFixed }}</p>
                </div>
            </div>
        </div>

        <div class="order-summary-table" v-if="step === 6">
            <div class="clear"></div>
            <div class="ost-header">
                <p class="ost-number">Lp.</p>
                <p class="ost-name">Nazwa usługi</p>
                <p class="ost-price">Kwota</p>
            </div>
            <div class="ost-entry">
                <p class="ost-number">1.</p>
                <p class="ost-name">
                    <em v-if="orderData.delivery.withCarry == 1"
                        >Dostawa z wniesieniem
                        {{ orderData.order.extOrderId }}</em
                    >
                    <em v-if="orderData.delivery.withCarry == 0"
                        >Dostawa {{ orderData.order.extOrderId }}</em
                    >
                </p>
                <p class="ost-price">
                    {{ orderData.delivery.cost | toFixed }} zł
                </p>
            </div>
            <div class="ost-summary">
                <p class="ost-number">&nbsp;</p>
                <p class="ost-name">SUMA</p>
                <p class="ost-price">
                    {{ orderData.delivery.cost | toFixed }} zł
                </p>
            </div>
            <div class="clear"></div>
        </div>

        <div v-if="step === 6 && orderType != ''">
            URL dla klienta:
            <div style="height: 60px">
                <input
                    type="text"
                    style="
                        border: 1px solid #ddd;
                        font-size: 20px;
                        width: 600px;
                    "
                    v-model="linkToPay"
                />
            </div>
        </div>
        <div
            class="ui one column grid container"
            v-if="step === 6 && orderType == ''"
        >
            <div class="column" id="payments-option-list">
                <div
                    v-for="(item, index) in methodsList"
                    :key="index"
                    class="payu-method"
                >
                    <img
                        v-bind:src="item.brandImageUrl"
                        alt=""
                        class="pay-method-logo"
                        style="
                            display: block !important;
                            margin: 5px auto 12px auto;
                        "
                    />
                    <input
                        type="radio"
                        name="payMethod"
                        :value="item.value"
                        v-model="orderData.order.payMethod"
                        style="display: inline-block"
                    />
                    {{ item.name }}
                </div>
            </div>
        </div>

        <payu-form :order="orderData.order" v-show="false"></payu-form>
        <div
            class="order-info-block acceptance-block mb-30"
            v-show="step === 6"
        >
            <input
                type="checkbox"
                id="payu-acceptance"
                name="payu-check"
                v-model="orderData.acceptPayuRules"
            /><label for="payu-check"
                >Akceptuję
                <a
                    href="http://static.payu.com/sites/terms/files/payu_terms_of_service_single_transaction_pl_pl.pdf"
                    style="display: inline-block"
                    >"Regulamin pojedynczej transakcji płatniczej PayU"</a
                >.</label
            >
            <p class="payu-info">
                Zlecenie realizacji płatności: Zlecenie wykonuje PayU SA; Dane
                odbiorcy, tytuł oraz kwota płatności dostarczane są PayU SA
                przez odbiorcę; Zlecenie jest przekazywane do realizacji po
                otrzymaniu przez PayU SA Państwa wpłaty. Płatność udostępniana
                jest odbiorcy w ciągu 1 godziny, nie później niż do końca
                następnego dnia roboczego; PayU SA nie pobiera opłaty od
                realizacji usługi.
            </p>
            <p class="payu-info payu-last">
                Administratorem Twoich danych osobowych w rozumieniu ustawy z
                dnia 29 sierpnia 1997 r. o ochronie danych osobowych (tj. Dz.U.
                z 2002 roku, nr 101, poz. 926 z późn. zm.) jest PayU SA z
                siedzibą w Poznaniu (60-166), przy ul. Grunwaldzkiej 182. Twoje
                dane osobowe będą przetwarzane zgodnie z obowiązującymi
                przepisami prawa, w celu świadczenia usług i archiwizacji. Twoje
                dane nie będą udostępniane innym podmiotom, z wyjątkiem
                podmiotów upoważnionych na podstawie przepisów prawa.
                Przysługuje Tobie prawo dostępu do treści swoich danych oraz ich
                poprawiania. Podanie danych jest dobrowolne, ale niezbędne do
                realizacji ww. celu.
            </p>
        </div>

        <form
            class="contactForm pb-20"
            target="_top"
            custom-validation-reporting="show-all-on-submit"
            v-show="step == 5"
        >
            <fieldset>
                <div class="order-header">
                    <i class="ion-person"></i>
                    <h2>Dane odbiorcy</h2>
                </div>
                <div class="order-info-block">
                    <p class="disclaimer">
                        Podając dane osobowe potwierdzam prawidłowość adresu
                        dostawy, kwot zamówień z Salonu Agata Meble, a także
                        pozostałych danych wprowadzonych w procesie rejestracji
                        zamówienia dostawy. Deklaruję tym samym chęć
                        skorzystania z oferty usługi transportowej zawartej w
                        formularzu.
                    </p>
                    <p class="disclaimer">
                        Wprowadzone dane osobowe wykorzystywane są jedynie w
                        procesie rejestracji zamówienia, jego realizacji,
                        kontroli jakości, a także notyfikowania użytkownika
                        drogą mailową i smsową o jego przebiegu.
                    </p>
                    <p class="disclaimer">
                        Wprowadzone dane nie są udostępniane osobom trzecim, ani
                        podmiotom zewnętrznym.
                    </p>
                </div>
                <div class="formFieldWrap">
                    <label
                        class="field-title orderStartPoint order-header-label"
                        for="orderStartPoint"
                    >
                    </label>
                    <input
                        type="text"
                        v-bind:class="{
                            'error-field':
                                customerFieldsError.FirstName == true,
                        }"
                        name="Name"
                        onfocus="(this.value == 'Imię') && (this.value = '')"
                        onblur="(this.value == '') && (this.value = 'Imię')"
                        v-model="orderData.customer.FirstName"
                        class="contactField"
                        id="Name"
                        required
                    /><span
                        visible-when-invalid="valueMissing"
                        validation-for="name5"
                    ></span>
                    <input
                        type="text"
                        v-bind:class="{
                            'error-field': customerFieldsError.LastName == true,
                        }"
                        name="Name"
                        onfocus="(this.value == 'Nazwisko') && (this.value = '')"
                        onblur="(this.value == '') && (this.value = 'Nazwisko')"
                        v-model="orderData.customer.LastName"
                        class="contactField"
                        id="Name"
                        required
                    />
                </div>
                <div class="formFieldWrap">
                    <label
                        class="field-title orderStartPoint order-header-label"
                        for="orderStartPoint"
                        ><i class=""></i>
                    </label>
                    <input
                        type="text"
                        v-bind:class="{
                            'error-field': customerFieldsError.Email == true,
                        }"
                        name="Name"
                        onfocus="(this.value == 'E-mail') && (this.value = '')"
                        onblur="(this.value == '') && (this.value = 'E-mail')"
                        v-model="orderData.customer.Email"
                        class="contactField"
                        id="Name"
                        required
                    /><span
                        visible-when-invalid="valueMissing"
                        validation-for="name5"
                    ></span>
                    <input
                        type="text"
                        v-bind:class="{
                            'error-field':
                                customerFieldsError.MobilePhone == true,
                        }"
                        name="Name"
                        onfocus="(this.value == 'Nr telefonu komórkowego') && (this.value = '')"
                        onblur="(this.value == '') && (this.value = 'Nr telefonu komórkowego')"
                        v-model="orderData.customer.MobilePhone"
                        class="contactField"
                        id="Name"
                        required
                    />
                </div>
                <div
                    class="order-info-block acceptance-block no-email-container"
                >
                    <input
                        type="checkbox"
                        name="noEmail"
                        v-model="noEmail"
                        id="noEmail"
                        class="noEmail"
                    />
                    <label for="noEmail" class="noEmail"
                        >Nie posiadam adresu e-mail i rezygnuję z powiadomień
                        dotyczących realizacji zlecenia</label
                    >
                </div>
            </fieldset>
            <fieldset>
                <div class="order-header">
                    <i class="ion-android-alert"></i>
                    <h2>Uwagi do zamówienia</h2>
                </div>
                <div class="order-info-block">
                    <p class="disclaimer">
                        Jeśli masz uwagi, które chciałbyś przekazać zespołowi
                        realizacyjnemu, wpisz je w poniższym polu.
                    </p>
                </div>
                <div class="formFieldWrap">
                    <textarea
                        class="order-form-comments"
                        rows="10"
                        cols="30"
                        v-model="orderData.remarks"
                    ></textarea>
                </div>
            </fieldset>

            <div class="order-info-block">
                <p class="error-message" v-show="customerDataError">
                    Prosimy o wypełnienie wszystkich pól.
                </p>
                <p
                    class="error-message"
                    v-show="
                        customerDataError &&
                        orderData.customer.MobilePhone != ''
                    "
                >
                    Prosimy o wpisanie właściwego numeru telefonu w formacie 9
                    cyfr nie rozdzielonych spacjami.
                </p>
            </div>
            <div class="order-info-block">
                <p class="disclaimer">
                    Jeżeli chcesz otrzymać fakturę VAT, prosimy o skorzystanie z
                    poniżej opcji, a następnie wypełnienie niezbędnych pól.
                </p>
            </div>
            <a
                href="#"
                v-on:click="showInfBox()"
                class="float-left button bg-blue full-bottom order-change-data-button"
                >Zmień dane do faktury</a
            >

            <fieldset v-show="showInvoicePart">
                <div class="order-header">
                    <i class="ion-document-text"></i>
                    <h2>Faktura VAT</h2>
                </div>
                <div class="order-info-block">
                    <p class="disclaimer">
                        Wprowadzone dane wykorzystywane są jedynie w celach
                        wystawienia Faktury VAT i nie są udostępniane osobom
                        trzecim, ani podmiotom zewnętrznym.
                    </p>
                    <p class="disclaimer">
                        Domyślnie załadowane zostają dane wprowadzone dotychczas
                        w procesie rejestracji zamówienia dostawy. Prosimy o ich
                        sprawdzenie i ewentualną zmianę.
                    </p>
                    <p class="disclaimer">
                        <b>UWAGA:</b> zmiana danych do faktury nie skutkuje
                        zmianą wprowadzonych danych osobowych i adresu
                        realizacji.
                    </p>
                </div>
                <div class="formFieldWrap">
                    <label
                        class="field-title orderStartPoint order-header-label"
                        for="orderStartPoint"
                        ><i class=""></i>
                    </label>
                    <input
                        type="text"
                        name="Name"
                        v-model="orderData.invoice.CompanyName"
                        placeholder="Nazwa firmy lub podmiotu"
                        class="contactField"
                        id="Company"
                        required
                    /><span
                        visible-when-invalid="valueMissing"
                        validation-for="name5"
                    ></span>
                    <input
                        type="text"
                        name="Name"
                        v-model="orderData.invoice.NIP"
                        placeholder="NIP"
                        class="contactField"
                        id="NIP"
                        required
                    />
                </div>
                <div class="formFieldWrap">
                    <label
                        class="field-title orderStartPoint order-header-label"
                        for="orderStartPoint"
                    >
                    </label>
                    <input
                        type="text"
                        name="Name"
                        placeholder="Imię"
                        v-model="orderData.invoice.FirstName"
                        class="contactField"
                        id="Name"
                        required
                    />
                    <input
                        type="text"
                        name="Name"
                        placeholder="Nazwisko"
                        v-model="orderData.invoice.LastName"
                        class="contactField"
                        id="Name"
                        required
                    />
                </div>
                <div class="formFieldWrap">
                    <label
                        class="field-title orderStartPoint order-header-label"
                        for="orderStartPoint"
                        ><i class=""></i>
                    </label>
                    <input
                        type="text"
                        name="Name"
                        v-model="orderData.invoice.Street"
                        placeholder="Ulica"
                        class="contactField"
                        id="Name"
                        required
                    /><span
                        visible-when-invalid="valueMissing"
                        validation-for="name5"
                    ></span>
                    <input
                        type="text"
                        name="Nr-budynku"
                        v-model="orderData.invoice.StreetNo"
                        placeholder="Nr budynku"
                        class="contactField order-field-name"
                        id="Number"
                        required
                    />
                    <input
                        type="text"
                        name="Nr-lokalu"
                        v-model="orderData.invoice.ApartmentNo"
                        placeholder="Nr lokalu"
                        class="contactField order-field-name"
                        id="Number"
                        required
                    />
                </div>
                <div class="formFieldWrap">
                    <label
                        class="field-title orderStartPoint order-header-label"
                        for="orderStartPoint"
                        ><i class=""></i>
                    </label>
                    <input
                        type="text"
                        name="Miejscowosc"
                        v-model="orderData.invoice.City"
                        placeholder="Miejscowość"
                        class="contactField"
                        id="Name"
                        required
                    /><span
                        visible-when-invalid="valueMissing"
                        validation-for="name5"
                    ></span>
                    <input
                        type="text"
                        name="Kod-pocztowy"
                        v-model="orderData.invoice.PostalCode"
                        maxlength="6"
                        placeholder="Kod pocztowy"
                        class="contactField order-field-name"
                        id="Name"
                        required
                    />
                </div>
            </fieldset>

            <div
                class="order-info-block"
                v-show="customerDataError && showInvoicePart"
            >
                <p class="error-message">
                    Prosimy o wypełnienie wszystkich niezbędnych pól.
                </p>
            </div>
        </form>
    </fieldset>
</template>

<script>
import PayuForm from "./PayuForm";
export default {
    name: "orderSummary",
    props: ["step", "orderData"],
    components: {
        PayuForm,
    },
    data() {
        return {
            methodsList: [],
            showInvoicePart: false,
            customerDataError: false,
            noEmail: false,
            customerFieldsError: {
                FirstName: false,
                LastName: false,
                Email: false,
                MobilePhone: false,
            },
            urls: {
                getPayMethodsList: "/api/getPaymentsMethods/",
            },
        };
    },

    methods: {
        getPayMethodsList: function () {
            var self = this;
            self.$http
                .get(
                    self.urls.getPayMethodsList +
                        "?pokId=" +
                        self.$store.state.pokId
                )
                .then(function (resp) {
                    self.methodsList = resp.data.methods;
                });
        },

        isValidMobilePhone: function (mobilePhone) {
            return /^\d{9}$/.test(mobilePhone);
        },

        showInfBox: function () {
            this.showInvoicePart = true;
            var cancelScroll = this.$scrollTo("body", 1000, { offset: 800 });
            //this.copyData();
        },

        copyData: function () {
            this.invoice.FirstName = this.orderData.customer.FirstName;
            this.invoice.LastName = this.orderData.customer.LastName;
            this.invoice.Street = this.orderData.address.Street;
            this.invoice.StreetNo = this.orderData.address.StreetNo;
            this.invoice.ApartmentNo = this.orderData.address.ApartmentNo;
            this.invoice.PostalCode = this.orderData.address.PostalCode;
            this.invoice.City = this.orderData.address.City;
        },

        emailIsValid: function (email) {
            return /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                email
            );
        },

        validateCustomer: function () {
            this.customerDataError = false;
            if (
                _.isEmpty(_.trim(this.orderData.customer.FirstName)) ||
                _.trim(this.orderData.customer.FirstName) === "Imię"
            ) {
                this.customerFieldsError.FirstName = true;
                this.customerDataError = true;
            }
            if (
                _.isEmpty(_.trim(this.orderData.customer.LastName)) ||
                _.trim(this.orderData.customer.LastName) === "Nazwisko"
            ) {
                this.customerFieldsError.LastName = true;
                this.customerDataError = true;
            }
            if (
                !this.noEmail &&
                (_.isEmpty(_.trim(this.orderData.customer.Email)) ||
                    _.trim(this.orderData.customer.Email) === "E-mail" ||
                    !this.emailIsValid(this.orderData.customer.Email))
            ) {
                this.customerFieldsError.Email = true;
                this.customerDataError = true;
            }
            if (_.isEmpty(_.trim(this.orderData.customer.MobilePhone))) {
                this.customerFieldsError.MobilePhone = true;
                this.customerDataError = true;
            }
            if (!this.isValidMobilePhone(this.orderData.customer.MobilePhone)) {
                this.customerFieldsError.MobilePhone = true;
                this.customerDataError = true;
            }
            console.log("FINISH validateCustomer");
            //this.$emit("setCustomerDataError", this.customerDataError);
        },
    },

    mounted: function () {
        var self = this;

        Event.$on("checkCustomerData", function () {
            self.validateCustomer();
            self.$emit("setCustomerDataError", self.customerDataError);
            console.log("emit checkCustomerData");
        });

        Event.$on("orderStep2", function (stepId) {
            console.log("orderStep - order summmary ");
            if (stepId == 6) {
                console.log("FINISH ORDER");
                //self.validateCustomer();
            }
        });
    },

    watch: {
        step: function (nv) {
            if (nv === 2) {
                this.getPayMethodsList();
            }
        },
    },

    computed: {
        orderType: function () {
            return this.$store.state.orderType;
        },
        linkToPay: function () {
            return this.$store.state.linkToPay;
        },
    },

    filters: {
        toFixed: function (val) {
            if (_.trim(val) == "") {
                return "";
            }
            var vNum = parseFloat(val);
            if (_.isNaN(vNum)) {
                return "-";
            }
            return vNum.toFixed(2);
            return "";
        },
    },
};
</script>
<style scoped>
.no-email-container {
    display: flex;
    align-items: center;
}
label.noEmail {
    margin: 0 0 0 15px;
}
</style>



// WEBPACK FOOTER //
// OrderSummary.vue?bb754174